import {Field} from 'formik';
import React from 'react';
interface FilterOptionsProps {
  options: Array<ICheckbox>;
}
const FilterOptions = ({options}: FilterOptionsProps) => {
  return (
    <div className=' w-full'>
      <p className='text-gray-5 mb-4'>نوع آگهی:</p>
      <div className="grid grid-cols-2 w-full gap-4 ">
        {options.map((item, index) => (
          <label
            key={index}
            className="flex items-center gap-2 text-[16px] font-medium text-gray-5"
          >
            <Field type="checkbox" name="type" value={item.value} />
            {item.name}
          </label>
        ))}
      </div>
      <div className="w-[90%]  flex" />
      <hr className=' my-4' />
    </div>
  );
};

export default FilterOptions;
